<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Psychiatry</h2>
      <p>
        The Department of Psychiatry provides confidential, compassionate care
        for patients with emotional, behavioural and psychiatric disorders.
      </p>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <img
          src="@/assets/img/psychiatry.png"
          alt="Psychiatry department"
          class="img-thumbnail img-thumbnail-box"
        />
      </div>
      <div class="col-lg-8">
        <p>
          The department offers comprehensive assessment and evidence-based
          treatment for conditions such as depression, anxiety disorders,
          psychosis, bipolar disorder, stress-related problems and behavioural
          disturbances.
        </p>
        <p>
          Care is provided through outpatient consultations, inpatient
          management when required and close coordination with other medical
          specialities. The focus is on restoring emotional well-being,
          improving daily functioning and supporting both patients and their
          families.
        </p>
      </div>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate3.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Psychiatry Doctors',
      queryName: 'Psychiatry',
      teamName: 'Psychiatry team',
    };
  },
  components: { DoctorsList },
});
</script>
